const data = {
  noModelMessage: 'No Models is being trained!',
  stoppingMessage: 'Training Stopped Successfully!',
  succesMessage: 'Training Stopped Successfully!',
  waitMessage:
    'Your request is being processed, Please wait for atleast 1 minute!',
};

export default data;
